import { uniqueStockTakeSupplierIds } from './stockTakeCreateForm'
import { getParLevelForProduct } from './parLevelPaywall'

const idFrom = value => {
  if (value == null || value === '') return ''
  if (typeof value === 'object') {
    return String(value._id || value.id || '').trim()
  }
  return String(value).trim()
}

export const stockTakeLineHasVenueProduct = (lines = [], venueProduct = {}) => {
  const venueProductId = idFrom(venueProduct?._id)
  const productId = idFrom(venueProduct?.product?._id || venueProduct?.product)
  return (Array.isArray(lines) ? lines : []).some(line => {
    if (venueProductId && idFrom(line?.venueProductId) === venueProductId) {
      return true
    }
    if (productId && idFrom(line?.productId) === productId) {
      return true
    }
    return false
  })
}

const supplierIdOnVenueProduct = venueProduct =>
  idFrom(venueProduct?.supplier) || idFrom(venueProduct?.product?.supplier)

/**
 * Shopping-list products with par, for this take’s suppliers, not already on
 * the count. One-tap adds them uncounted.
 */
export const listMissingParProductsForSuppliers = ({
  venueProducts = [],
  stockTakeLines = [],
  supplierIds = [],
} = {}) => {
  const suppliers = uniqueStockTakeSupplierIds(supplierIds)
  if (!suppliers.length) return []
  const supplierSet = new Set(suppliers)

  return (Array.isArray(venueProducts) ? venueProducts : []).filter(
    venueProduct => {
      if (!venueProduct || venueProduct.isActive === false) return false
      if (getParLevelForProduct(venueProduct) <= 0) return false
      if (!supplierSet.has(supplierIdOnVenueProduct(venueProduct))) return false
      if (stockTakeLineHasVenueProduct(stockTakeLines, venueProduct)) {
        return false
      }
      return Boolean(idFrom(venueProduct._id))
    },
  )
}

export const formatMissingParStripCopy = (count, { supplierCount } = {}) => {
  const n = Number(count) || 0
  if (n <= 0) return null
  const products = n === 1 ? 'product' : 'products'
  const suppliers =
    Number(supplierCount) === 1 ? 'this supplier' : 'these suppliers'
  return `${n} par ${products} for ${suppliers} ${
    n === 1 ? 'is' : 'are'
  } not on this count.`
}
